import type {ManifestFeatureComponentStageGfpp} from '@wix/document-services-types'
import {pickBy} from 'lodash'
import {ActionsHelpers} from '../actions/ActionsHelpers'
import {DisplayFiltersActions} from './DisplayFiltersActions'

export class DisplayFiltersCustomActionsBuilder extends DisplayFiltersActions {
    constructor(private readonly gfpp: ManifestFeatureComponentStageGfpp | undefined) {
        super()
    }

    protected getHiddenActions = () => {
        const gfppFromStage = this.gfpp?.desktop || {}
        const {mainAction1, mainAction2, iconButtons} = gfppFromStage
        const hiddenMainActions = pickBy({mainAction1, mainAction2}, ActionsHelpers.isActionHidden)
        const hiddenIconButtons = iconButtons ? pickBy(iconButtons, ActionsHelpers.isActionHidden) : undefined

        const {mainActions, supportedIconButtons} = ActionsHelpers.prepareCustomActionValues({
            ...hiddenMainActions,
            iconButtons: hiddenIconButtons
        })

        const customActions = hiddenIconButtons
            ? pickBy(hiddenIconButtons, (_, key) => supportedIconButtons.has(key))
            : {}

        return {...mainActions, ...customActions}
    }
}
